function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m421 76c0 8.285156-6.714844 15-15 15s-15-6.714844-15-15 6.714844-15 15-15 15 6.714844 15 15zm0 0",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m361 76c0 8.285156-6.714844 15-15 15s-15-6.714844-15-15 6.714844-15 15-15 15 6.714844 15 15zm0 0",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m301 76c0 8.285156-6.714844 15-15 15s-15-6.714844-15-15 6.714844-15 15-15 15 6.714844 15 15zm0 0",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m482 401.792969v-346.796875c0-30.324219-24.671875-54.996094-54.996094-54.996094h-372.007812c-30.324219 0-54.996094 24.671875-54.996094 54.996094v372.007812c0 30.324219 24.671875 54.996094 54.996094 54.996094h126.457031c-.445313 4.941406-.683594 9.941406-.683594 15 0 8.285156 6.714844 15 15 15h301.230469c8.285156 0 15-6.714844 15-15 0-35.394531-11.105469-68.230469-30-95.207031zm-427.003906-371.792969h372.007812c13.78125 0 24.996094 11.214844 24.996094 24.996094v66.003906h-422v-66.003906c0-13.78125 11.214844-24.996094 24.996094-24.996094zm0 422c-13.78125 0-24.996094-11.214844-24.996094-24.996094v-276.003906h422v218.1875c-92.269531-76.789062-232.695312-32.277344-265.046875 82.8125zm311.742187 30 21.972657-66.648438c2.59375-7.867187-1.683594-16.347656-9.550782-18.941406-7.863281-2.597656-16.347656 1.683594-18.941406 9.550782l-25.066406 76.039062h-123.5625c7.464844-67.992188 65.070312-121.0625 134.796875-121.0625 69.722656 0 127.328125 53.070312 134.796875 121.0625zm0 0",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m76 271h331c8.285156 0 15-6.714844 15-15v-60c0-8.285156-6.714844-15-15-15h-331c-8.285156 0-15 6.714844-15 15v60c0 8.285156 6.714844 15 15 15zm15-60h301v30h-301zm0 0",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m76 332h165c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15h-165c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15zm0 0",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m181 361h-105c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h105c8.285156 0 15-6.714844 15-15s-6.714844-15-15-15zm0 0",
    "data-original": "#000000",
    style: {},
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.290e563bf9a11a6a329f5e452c5f7759.svg";
export { ForwardRef as ReactComponent };